import * as React from "react";
import sideImage from "../../../assets/sample-image.png"
import crossedEye from "../../../assets/icons/crossed-eye.svg"
import classes from './VerifyResetPassword.module.scss'
import { Field, Form, Formik } from "formik";
import { LoginFormInitialValues, LoginFormValidation } from "../../../validations/AuthValidations";
import { Input } from "../../../components/Inputs/Input";
import { useState } from "react";

export const VerifyResetPassword = () => {
    const [passwordInput, setPasswordInput] = useState('password');
    const handleLogin = (values, resetForm) => {
        console.log({ values });
    }
    return (
        <>
            <div className={classes.parentContainer}>
                <img
                    src={sideImage}
                    alt="decorator"
                    className={classes.sideImage}
                />

                <div className={classes.div}>
                    <div className={classes.div2}>Create New Password</div>
                    <Formik
                        enableReinitialize
                        initialValues={LoginFormInitialValues}
                        validationSchema={LoginFormValidation}
                        onSubmit={(val, { resetForm }) => handleLogin(val, resetForm)}
                    >
                        {({ errors, touched, values, isValidating, handleSubmit, ...props }) => {
                            return (
                                <Form>
                                    <div>
                                        <div className={classes.div3}>
                                            <div className={classes.div11}>
                                                <label className={classes.div6} htmlFor='password'>Password</label>

                                                <div className={classes.div4}>
                                                    {passwordInput === 'password' ? (
                                                        <>
                                                            <div className={classes.div7}>Show</div>
                                                            <img
                                                                className={classes.img}
                                                                src={crossedEye}
                                                                alt="hidden password"
                                                                onClick={() => setPasswordInput('text')}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className={classes.div7}>Hide</div>
                                                            <img
                                                                className={classes.img}
                                                                src={crossedEye}
                                                                onClick={() => setPasswordInput('password')}
                                                                alt="unhidden password"
                                                            />
                                                        </>
                                                    )}

                                                </div>


                                            </div>
                                            <Field
                                                className={classes.div8}
                                                type={passwordInput}
                                                name='password'
                                                id='password'
                                                placeholder='Password'
                                            />

                                            {errors.password && touched.password ? (
                                                <div className='error'>{errors.password}</div>
                                            ) : null}
                                        </div>
                                        <div className={classes.div3}>
                                            <Input name='confirmPassword' type='password' placeholder='' label='Confirm Password' required />
                                        </div>
                                        <div className={classes.div10}>Reset Password</div>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                </div>
            </div>
        </>
    );
}
